import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { label: 'HOME', to: '/#home' },
  { label: 'PORTALS', to: '/#portals' },
  { label: 'OSINT', to: '/#osint' },
  { label: 'TRAINING', to: '/#training' },
  { label: 'CYBER LAWS', to: '/#laws' },
  { label: 'PRICING', to: '/pricing' },
  { label: 'CONTACT', to: '/contact' },
];

const Navbar = ({ onPoliceLogin, onCitizenPortal, liveClock }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (

    <nav className="bg-white/90 backdrop-blur-xl border-b border-cyan-500/30 sticky top-0 z-50 shadow-2xl shadow-cyan-500/5">
      <div className="max-w-7xl mx-auto px-4 py-3.5 flex justify-between items-center">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center text-xl shadow-lg shadow-cyan-500/30">
            <i className="fa-solid fa-shield-halved" />
          </div>
          <div>
            <h1 className="text-2xl font-black rajdhani tracking-widest" style={{ color: '#f2b705', textShadow: '0 0 12px rgba(242,183,5,0.5)' }}>
              CYBER SECURE INDIA  
            </h1>
            <p className="text-[10px] text-gray-600 mono tracking-widest -mt-1">NATIONAL CYBER INTELLIGENCE PLATFORM</p>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-6 text-sm font-semibold rajdhani tracking-wide">
          {navItems.map((item) => (
            <Link key={item.label} to={item.to} className="hover:text-cyan-400 transition-colors text-gray-700">
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          {/* {liveClock && (
            <span className="text-xs text-cyan-300 mono hidden xl:block">{liveClock}</span>
          )} */}
          <button
            type="button"
            onClick={onPoliceLogin}
            className="px-4 py-2.5 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-500 font-bold text-white hover:scale-105 transition-all shadow-lg shadow-cyan-500/20 flex items-center gap-2 text-sm rajdhani tracking-wide"
          >
            <i className="fa-solid fa-user-shield" /> POLICE LOGIN
          </button>
          <button
            type="button"
            onClick={onCitizenPortal}
            className="px-4 py-2.5 rounded-xl border border-cyan-600/50 text-cyan-700 font-bold hover:bg-cyan-500 hover:text-white transition-all flex items-center gap-2 text-sm rajdhani tracking-wide"
          >
            <i className="fa-solid fa-user-lock" /> CITIZEN PORTAL
          </button>
          <button
            type="button"
            onClick={() => navigate('/admin-login')}
            className="w-9 h-9 rounded-xl border border-violet-500/30 text-violet-400/70 hover:bg-violet-500/15 hover:text-violet-300 hover:border-violet-400/60 transition-all flex items-center justify-center"
            title="Super Admin Panel"
          >
            <i className="fa-solid fa-crown text-sm" />
          </button>
        </div>

        <button type="button" onClick={() => setMenuOpen((prev) => !prev)} className="lg:hidden text-cyan-400 text-2xl">
          <i className="fa-solid fa-bars" />
        </button>
      </div> 
      <div className={`lg:hidden flex-col bg-white/95 border-t border-cyan-500/20 px-6 py-4 gap-4 ${menuOpen ? 'flex' : 'hidden'}`}>
        {navItems.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            onClick={() => setMenuOpen(false)}
            className="block py-2 text-gray-700 hover:text-cyan-400 rajdhani font-semibold"
          >
            {item.label}
          </Link>
        ))}
        <button
          type="button"
          onClick={() => { onPoliceLogin(); setMenuOpen(false); }}
          className="w-full py-3 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-500 font-bold text-white rajdhani tracking-wide"
        >
          POLICE LOGIN
        </button>
        <button
          type="button"
          onClick={() => { onCitizenPortal(); setMenuOpen(false); }}
          className="w-full py-3 rounded-xl border border-cyan-600 text-cyan-700 font-bold rajdhani tracking-wide"
        >
          CITIZEN PORTAL
        </button>
        <button
          type="button"
          onClick={() => { navigate('/admin-login'); setMenuOpen(false); }}
          className="w-full py-3 rounded-xl border border-violet-500/40 text-violet-400 font-bold rajdhani tracking-wide flex items-center justify-center gap-2"
        >
          <i className="fa-solid fa-crown" /> SUPER ADMIN
        </button>
      </div>
    </nav>

  );
};

export default Navbar;
